import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/opt/build/repo/domains/commerce/layouts/default.vue").then(m => m.default || m))
}